import * as types from './types'
export default {
  [types.RESET_LOOKUPS](state) {
    state.lookups = {}
  },
  [types.SET_LOOKUPS](state, [keys, lookups]) {
    let _lookups = {}
    for (let key of keys) {
      _lookups[key] = []
      for (let lookup of lookups) {
        if (lookup.key === key) {
          lookup.id = lookup.id
          lookup.value = lookup.intValue
          lookup.name = (lookup.text !== null) ? lookup.text : lookup.stringValue
          lookup.altValue = lookup.value
          lookup.stringValue = lookup.stringValue
          lookup.infoBubble = lookup.infoBubble
          _lookups[key].push(lookup)
        }
      }
    }
    state.lookups = JSON.parse(JSON.stringify(Object.assign(state.lookups, _lookups)))
  },
  [types.SET_LOOKUPS_ZEUS](state, [key, lookups]) {
    let _lookups = {}
    if (Object.keys(state.lookupsZeus).length === 0 && state.lookupsZeus.constructor === Object) {
      _lookups = state.lookupsZeus
    }
    _lookups[key] = []
    for (let lookup of lookups) {
      let _value = null
      if (key === 'device.applayerprotocol') {
        _value = lookup.value
      } else {
        _value = lookup.id
      }
      let _lookup = {
        name: lookup.text,
        value: _value,
        altValue: lookup.value
      }
      _lookups[key].push(_lookup)
    }
    state.lookupsZeus = JSON.parse(JSON.stringify(Object.assign(state.lookupsZeus, _lookups)))
  },
  [types.SET_TIMEZONES](state, data) {
    state.timeZones = []
    let _timeZones = []
    for (let timezone of data) {
      timezone.value = timezone.name
      _timeZones.push(timezone)
    }
    state.timeZones = JSON.parse(JSON.stringify(Object.assign(state.timeZones, _timeZones)))
  },
  [types.UPSERT_LOOKUP](state, [lookup, id]) {
    lookup.id = id
    let section = state.groups.filter(
      group => group.sectionName === lookup.section
    )
    if (section.length > 0) {
      let index = section[0].children.findIndex(i => i.id === lookup.id)
      if (index >= 0) {
        section[0].children[index] = {
          id: lookup.id,
          key: lookup.key,
          section: lookup.section,
          text: lookup.text,
          value: lookup.stringValue,
          intValue: lookup.intValue,
          dateValue: lookup.dateValue
        }
      } else {
        section[0].children.push({
          id: lookup.id,
          key: lookup.key,
          section: lookup.section,
          text: lookup.text,
          value: lookup.stringValue,
          intValue: lookup.intValue,
          dateValue: lookup.dateValue
        })
      }
    }
  },
  [types.DELETE_LOOKUP](state, lookup) {
    try {
      let section = state.groups.filter(
        group => group.sectionName === lookup.section
      )
      if (section.length > 0) {
        let index = section[0].children.findIndex(i => i.id === lookup.id)
        section[0].children.splice(index, 1)
      }
    } catch (e) {
    }
  },
  [types.SET_GROUPS](state, groups) {
    state.groups = groups
  },
  [types.UPSERT_GROUP](state, data) {
    let group = state.groups.filter(
      g => g.id === data.id
    )
    if (group.length > 0) {
      group[0].sectionName = data.text
    }
  },
  [types.SET_INSURANCE_COMPANIES](state, companies) {
    state.insuranceCompanies = []
    if (companies !== undefined && companies !== null) {
      for (let item of companies) {
        state.insuranceCompanies.push({
          name: item.name,
          value: item.id
        })
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/lookups/mutations.js